import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import { DIV } from 'src/components/CustomStyledComponents';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoCompra from 'src/components/InfoCompra';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import useEstadoSuscripcion from "src/hooks/useEstadoSuscripcion"
import ProgressBar from 'react-bootstrap/esm/ProgressBar';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import InfoPtp from 'src/components/InfoPtp';
import Timer from 'src/components/Counter';
import {URL_PLUGIN_FRONTEND} from 'src/parametros'

const TAG = "cambioSuscripcion"

const FinCambioSuscripcion = ({ params, cotizacion, idCotizacion, ...props }) => {
    const { idSuscripcion } = params;
    const [estadoPago2, setestadoPago2] = useState({});
    const { loading: loadingSuscripcion, estado, verificarSuscripcion } = useEstadoSuscripcion({ idSuscripcion, idCotizacion })
    const { ESTADOS_SUSCRIPCION } = usePtp();
    const [verificandoEstado, setVerificandoEstado] = useState(false);
    const { pagarPagosPendientes, loading, consultarEstadoPago } = usePtp()
    const history = useHistory();
    const { addErrorToast, addWarningToast, addSuccessToast } = useCustomToast();
    const textos = cotizacion?.configuracion?.textos?.[TAG] ?? ""
    const [pageProps, setPageProps] = useState({
        titulo: textos?.titulo || 'Suscripción de tarjeta completada',
        subtitulo: textos?.subtitulo ?? "",
        goBack: ``,
        periocidadPago: 'Los cobros se han realizado',
        label: 'Pagos realizados',
        total: 0
    });

    const [error, seterror] = useState("")
    const init = async () => {
        const { transaccion = false, total = 0, errorDescripcion = "" } = await pagarPagosPendientes();
        if (!transaccion) {
            // setPageProps({ ...pageProps, periocidadPago: "Cobros pendientes no realizados", label: "Pagos pendientes" })
            addErrorToast(`${errorDescripcion ?? ""}`);
            seterror(`${errorDescripcion ?? ""}`)
        } else {
            setPageProps({ ...pageProps, total })
        }
    }
    useEffect(() => {
        verificarSuscripcion();
    }, []);
    // useEffect(() => {
    //     setestadoPago2(estado?.data)
    //     let bucle = null
    //     if (estado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE) {
    //         bucle = setInterval(async () => {
    //             setVerificandoEstado(true);
    //             await verificarSuscripcion();
    //             setVerificandoEstado(false);
    //         }, 60000);
    //     } else if (estado?.estado === ESTADOS_SUSCRIPCION.APROBADO) {
    //         init()
    //     }
    //     return () => {
    //         clearInterval(bucle)
    //     };

    // }, [estado]);


    useEffect(() => {
        let bucle = null;
        setestadoPago2(estado?.data)
        if (estado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE) {
            bucle = setInterval(async () => {
                setVerificandoEstado(true);
                const traEstado = await consultarEstadoPago();
                if (traEstado.hasError) {
                    addWarningToast('Ha ocurrido un problema al verificar el estado de la suscripción');
                }
                else if (traEstado.estado === ESTADOS_SUSCRIPCION.APROBADO) {
                    addSuccessToast(`Transacción aprobada \nRef: ${traEstado.data?.pago_id}`)
                    clearInterval(bucle);
                    init();
                    // redireccionar();
                }
                else if (traEstado.estado === ESTADOS_SUSCRIPCION.RECHAZADO) {
                    addErrorToast(`Transacción rechazada \nRef: ${traEstado?.data?.pago_id}`)
                    clearInterval(bucle);
                    setestadoPago2(traEstado);
                }
                setVerificandoEstado(false);

            }, 60000);
            //}, 5000);
        } else if (estado?.estado === ESTADOS_SUSCRIPCION.APROBADO) {
            Axios.post(`${URL_PLUGIN_FRONTEND}cotizacion/notificar&idCotizacion=${idCotizacion}`,{});
            init()
        }

        return () => {
            clearInterval(bucle);
        };
    }, [estado, idSuscripcion]);



    const loadValues = { ...loadingSuscripcion.values, loading: loading || loadingSuscripcion.values.loading };

    console.log("textos", pageProps.total === 0 ? pageProps.label : "Cambio de suscripción")
    return (
        <LoadingWrapper  {...loadValues} >
            <DIV stylePath="" className="container-fluid container-page">
                <NavbarHeader showBack={false} />
                <HeaderPage progreso={100} />
                {estado?.estado !== ESTADOS_SUSCRIPCION.APROBADO ?
                    <>
                        <div className="row justify-content-center">
                            <div className="col-11 col-md-7 mt-3">
                                <h4 className="titulo font-weight-bold">
                                    {textos?.titulo || "Estado de la suscripción"
                                    }
                                </h4>
                                <p className="descripcion">
                                    {textos?.subTitulo || "A continuación se detalla el estado de su suscripción"}
                                </p>
                            </div>
                        </div>
                        <InfoPtp
                            valor="1"
                            resultado={estado?.estado}
                            referencia={idCotizacion}
                            pago={estadoPago2}
                            label="Cobro prueba"
                            periocidadPago="El cobro realizado sera reversado de forma automatica"
                        >
                            <React.Fragment>
                                {estado?.estado === ESTADOS_SUSCRIPCION.RECHAZADO && (
                                    <div className="col-11 col-sm-8 col-md-6 text-center mt-5">
                                        <h6 className="label__rechazado">
                                            Su petición de suscripción de tarjeta ha sido <strong>rechazada</strong>
                                        </h6>
                                    </div>
                                )}

                                <div className="col-12" />
                                {estado?.estado === ESTADOS_SUSCRIPCION.PENDIENTE &&
                                    !verificandoEstado && (
                                        <div className="col-11 col-sm-8 col-md-6 mt-4">
                                            <h5 className="label__pendiente font-weight-bold text-secondary text-justify">
                                                Al parecer el proceso de verificación está tardando más de
                                                lo esperado, pronto seras notificado a tu correo{' '}
                                                {cotizacion.titular.email}
                                            </h5>

                                            <h5 className="label__timer mt-3">
                                                Se volvera a consultar en{' '}
                                                <Timer
                                                    initialTime={60000}
                                                    //initialTime={5000}
                                                    direction="backward"
                                                //onFinish={() => setTimeFinished(true)}
                                                />
                                                {' segundos'}
                                            </h5>
                                        </div>
                                    )}
                                <div className="col-12" />
                                <div className="col-11 col-sm-8 col-md-6">
                                    {verificandoEstado && (
                                        <ProgressBar
                                            className="progresbar__pendiente my-5"
                                            animated
                                            now={100}
                                            label="Verificando estado..."
                                        />
                                    )}
                                </div>
                                <div className="col-12" />
                                <BtnPrincipal label="Mis pagos" onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)} />
                            </React.Fragment>
                        </InfoPtp>

                        {estado?.estado === ESTADOS_SUSCRIPCION.RECHAZADO && (
                            <FooterButton label="Intentar nuevamente" onClick={() => history.push(`/cambiosuscripcionptp/${idCotizacion}`)} />
                        )}
                    </>
                    :
                    <div className="row justify-content-center">
                        <>
                            {pageProps && (
                                <div className="col-11 col-md-6 mt-3">
                                    <h4 className="titulo font-weight-bold">{pageProps?.titulo}</h4>
                                    <p className="descripcion">{pageProps?.subtitulo || 'Su cambio de suscripción fue realizado exitosamente. Los próximos cobros serán debitados de esta tarjeta'}</p>
                                </div>
                            )}
                            {console.log("error", error)}
                            {error &&
                                <div className="col-10 my-5">
                                    <p className="text-center">{error}</p>
                                    <div className={'text-center'} >
                                        <BtnPrincipal
                                            label="Cambiar tarjeta"
                                            onClick={() => history.push(`/cambiosuscripcionptp/${idCotizacion}`)}
                                        />
                                    </div>
                                </div>
                            }
                            {!error &&
                                <InfoCompra
                                    label={+pageProps.total !== 0 ? pageProps.label : "Cambio de suscripción"}
                                    total={+pageProps.total !== 0 ? pageProps.total : ""}
                                    periocidadPago={+pageProps.total !== 0 ? pageProps.periocidadPago : 'Los próximos cobros serán debitados de su nueva tarjeta'}
                                />
                            }
                            <div className="col-10 col-sm-8 text-center">
                                <h6 style={{ fontSize: '14px' }}>Felicidades, {cotizacion.titular.nombre1}</h6>
                                {/* {envioCorreoCliente !== 'true' && <p>Gracias por preferirnos</p>} */}
                                <BtnPrincipal
                                    label="Mis pagos"
                                    onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}?finsuscripcion=true`)}
                                />
                            </div>
                        </>
                    </div>
                }

            </DIV>
        </LoadingWrapper >
    );
};

export default withCotizacion(FinCambioSuscripcion);
